import React, { useEffect, useState } from "react";

import {
    Grid,
    TextField,
    Button,
    Typography,
    Dialog,
    DialogContent,
    Paper,
    Select,
    FormControl,
    InputLabel,
} from "@material-ui/core/";
import { toast } from "react-toastify";
import QrReader from "react-qr-reader";

import EventApi from "../../services/event";
import TotemResult from "./TotemResult";

import { Top, Bottom, Align } from "./styles";
import { config } from "../../config";

const Totem = (props) => {
    const [people, setPeople] = useState([]);
    const [status, setStatus] = useState([]);
    const [search, setSearch] = useState("");
    const [open, setOpen] = useState(false);
    const [event, setEvent] = useState({});
    const [state, setState] = useState(true);
    const [rows, setRows] = useState([[]]);
    const [searchType, setSearchType] = useState("name");
    const [qrScan, setQrScan] = useState({ delay: 300, result: "Posicione o QR code para leitura" });

    const getDay = () => {
        let today = new Date();
        return today.getDate();
    };

    const isValidForToday = (day1, day2, day3) => {
        let today = getDay();
        switch (today) {
            case 17:
                return day1;
            case 18:
                return day2;
            case 19:
                return day3;
            default:
                return false;
        }
    };

    function onChange(event) {
        setSearch(event.target.value);
    }

    function onChangeSearchType(event) {
        setSearchType(event.target.value);
    }

    function handleScan(data) {
        if (!!data) {
            console.log(data);
            searchByQrCode(data);
        }
    }

    function handleScanError(err) {
        console.log(err);
        toast.error("Não foi possível ler o QR Code");
    }

    function stopScan() {
        setSearchType("name");
    }

    function searchByQrCode(qrcodeData) {
        const id = qrcodeData;
        EventApi.getPersonById(id)
            .then((resp) => {
                if (!!resp.data) {
                    if (!!resp.data.data) {
                        console.log(resp.data.data);
                        setPeople([resp.data.data]);

                        if (!isValidForToday(resp.data.data.day_1, resp.data.data.day_2, resp.data.data.day_3)) {
                            throw new Error("Ingresso Inválido para esse dia");
                        }

                        EventApi.getStatus()
                            .then((respStatus) => {
                                if (!!respStatus.data) {
                                    respStatus.data.data.forEach((item) => {
                                        const { id } = item;
                                        const data = status;
                                        data[id] = item;
                                        setStatus(data);
                                    });
                                }
                            })
                            .catch(function (error) {
                                toast.error(error);
                            });
                    } else toast.error("Convidado não encontrado");
                } else toast.error("Convidado não encontrado");
            })
            .catch(function (error) {
                toast.error(error);
            });
        setSearch("");
        stopScan();
        handleOpen();
    }

    useEffect(() => {
        async function getData() {
            const respEvent = await EventApi.getEvent(props.computedMatch.params.event_id);
            if (!!respEvent.data) {
                setEvent(respEvent.data.data);
                console.log(respEvent.data.data);
                EventApi.getPositionByEvent(props.computedMatch.params.event_id)
                    .then((respPos) => {
                        if (respPos.data) {
                            const positions = Array(respEvent.data.data.lines)
                                .fill()
                                .map((u) =>
                                    Array(respEvent.data.data.columns)
                                        .fill()
                                        .map((u) => null)
                                );
                            respPos.data.data.forEach((item) => {
                                const posit = {
                                    id: item.id,
                                    number: item.value,
                                    isSelected: false,
                                    isReserved: true,
                                };
                                positions[parseInt(item.line, 10)][parseInt(item.column, 10)] = posit;
                            });
                            setRows(positions);
                        } else {
                            toast.error("Posições não encontradas");
                            setState(false);
                        }
                    })
                    .catch(function (error) {
                        toast.error(error);
                    });
            } else {
                toast.error("Evento não encontrado");
                setState(false);
            }
        }

        getData();
    }, []);

    async function onSubmit(event) {
        event.preventDefault();
        if (searchType !== "qrcode") {
            if (searchType !== "position") {
                if (searchType === "name") {
                    EventApi.getPersonByEvent(props.computedMatch.params.event_id, { name: search })
                        .then((resp) => {
                            if (!!resp.data) {
                                if (!!resp.data.data) {
                                    console.log(resp.data.data);
                                    setPeople(resp.data.data);
                                    // EventApi.getStatus()
                                    //     .then((respStatus) => {
                                    //         if (!!respStatus.data) {
                                    //             respStatus.data.data.forEach((item) => {
                                    //                 const { id } = item;
                                    //                 const data = status;
                                    //                 data[id] = item;
                                    //                 setStatus(data);
                                    //             });
                                    //         }
                                    //     })
                                    //     .catch(function (error) {
                                    //         toast.error(error);
                                    //     });
                                } else toast.error("Convidado não encontrado");
                            } else toast.error("Convidado não encontrado");
                        })
                        .catch(function (error) {
                            toast.error(error);
                        });
                } else {
                    EventApi.getPersonById(search)
                        .then((resp) => {
                            if (!!resp.data) {
                                if (!!resp.data.data) {
                                    console.log(resp.data.data);
                                    setPeople([resp.data.data]);
                                    // EventApi.getStatus()
                                    //     .then((respStatus) => {
                                    //         if (!!respStatus.data) {
                                    //             respStatus.data.data.forEach((item) => {
                                    //                 const { id } = item;
                                    //                 const data = status;
                                    //                 data[id] = item;
                                    //                 setStatus(data);
                                    //             });
                                    //         }
                                    //     })
                                    //     .catch(function (error) {
                                    //         toast.error(error);
                                    //     });
                                } else toast.error("Convidado não encontrado");
                            } else toast.error("Convidado não encontrado");
                        })
                        .catch(function (error) {
                            toast.error(error);
                        });
                }
            } else {
                EventApi.getPeopleByPosition(props.computedMatch.params.event_id, { value: search })
                    .then((resp) => {
                        console.log(resp.data.data);
                        if (!!resp.data.data) {
                            if (resp.data.data.people.length > 0) {
                                setPeople(resp.data.data.people);
                                EventApi.getStatus()
                                    .then((respStatus) => {
                                        if (!!respStatus.data) {
                                            respStatus.data.data.forEach((item) => {
                                                const { id } = item;
                                                const data = status;
                                                data[id] = item;
                                                setStatus(data);
                                            });
                                        }
                                    })
                                    .catch(function (error) {
                                        toast.error(error);
                                    });
                            } else toast.error("Convidado não encontrado");
                        } else toast.error("Convidado não encontrado");
                    })
                    .catch(function (error) {
                        toast.error(error);
                    });
            }
        } else {
            console.log("qrcode search");
        }
        setSearch("");
        handleOpen();
    }

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Align>
                <Grid container direction="column" justifyContent="space-between" alignItems="stretch" spacing={2}>
                    <Grid direction="column" justifyContent="flex-start" xs>
                        <Top>
                            <Paper
                                style={{ borderRadius: 30, minWidth: "50%", minHeight: "30%", opacity: "0.8" }}
                                elevation={10}
                            >
                                <Typography style={{ padding: "1%", color: "#175D90" }} variant="h3">
                                    Seja bem-vindo(a) ao {config.EVENT_NAME}!
                                </Typography>
                            </Paper>
                        </Top>
                    </Grid>
                    <Grid container direction="column" justifyContent="flex-end">
                        <Bottom>
                            <form style={{ width: "50%" }} onSubmit={onSubmit}>
                                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel>Buscar por:</InputLabel>
                                        <Select
                                            native
                                            defaultValue={searchType}
                                            onChange={onChangeSearchType}
                                            value={searchType}
                                        >
                                            <option value={"name"}>Nome</option>
                                            {/* <option value={"email"}>Email</option> */}
                                            {/* <option value={'id'}>ID</option>
                                        <option value={'position'}>Posição</option>
                                        <option value={'qrcode'}>QR Code</option> */}
                                        </Select>
                                    </FormControl>
                                    {searchType !== "qrcode" ? (
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            margin="normal"
                                            required
                                            label={searchType === "name" ? "Nome" : "Email"}
                                            onChange={onChange}
                                            value={search}
                                            autoFocus
                                        />
                                    ) : (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <QrReader
                                                delay={100}
                                                style={{
                                                    height: "30%",
                                                    width: "30%",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                                onError={handleScanError}
                                                onScan={handleScan}
                                                facingMode="environment"
                                            />
                                            <p style={{ fontSize: "20px", textAlign: "center" }}>{qrScan.result}</p>
                                        </div>
                                    )}
                                </Grid>
                                {searchType !== "qrcode" ? (
                                    <div>
                                        <Button type="submit" fullWidth variant="contained" color="primary">
                                            Buscar
                                        </Button>
                                    </div>
                                ) : null}
                            </form>
                            <Grid>
                                <div style={{ maxWidth: "100%" }}>
                                    <Dialog fullScreen open={open} onClose={handleClose}>
                                        <DialogContent style={{ background: "#ecf1f8" }}>
                                            <TotemResult data={{ people, status, event, rows }} close={handleClose} />
                                        </DialogContent>
                                    </Dialog>
                                </div>
                            </Grid>
                        </Bottom>
                    </Grid>
                </Grid>
            </Align>
        </>
    );
};

export default Totem;
